<template>
  <div class="cell total" :class="'cell__' + column">
    <template v-if="column === 'worker'"> Итого за месяц </template>

    <template v-if="column === 'days'">
      <div class="timeline">
        <div v-for="day in stats.days" :key="day.key" class="day">
          {{ Math.round(day.totalTimeMin / 60) }}
        </div>
      </div>
    </template>

    <template v-if="column === 'totalShifts'">
      <div class="shifts">
        {{ stats.dayShiftsCount + stats.nightShiftsCount }}/{{ stats.calcDayShiftsCount + stats.calcNightShiftsCount }}
      </div>
    </template>

    <template v-if="column === 'workTime'">
      <div class="work-time">
        <div>{{ formatTime(stats.totalTimeMin) }}</div>
        <div>{{ formatTime(stats.calcTotalTimeMin) }}</div>
      </div>
    </template>

    <template v-if="column === 'compensation'">
      {{ stats.compensation.toLocaleString() }}
    </template>

    <template v-if="column === 'load'">
      {{ stats.load.toLocaleString() }}
    </template>

    <template v-if="column === 'salary'">
      {{ stats.salary.toLocaleString() }}
    </template>

    <template v-if="column === 'salaryMainPart'">
      <div class="salary-main">
        <div>{{ Math.floor(stats.salaryMain || 0).toLocaleString() }}</div>
        <div>{{ Math.floor(stats.calcSalaryMain || 0).toLocaleString() }}</div>
      </div>
    </template>

    <template v-if="column === 'excessPremium'">
      {{ stats.excessPremium.toLocaleString() }}
    </template>

    <template v-if="column === 'Depreciation'">
      {{ stats.depreciation.toLocaleString() }}
    </template>

    <template v-if="column === 'premium'">
      {{ stats.premium.toLocaleString() }}
    </template>

    <template v-if="column === 'fine'">
      {{ stats.fine.toLocaleString() }}
    </template>

    <template v-if="column === 'penalties'">
      {{ stats.penalties.toLocaleString() }}
    </template>

    <template v-if="column === 'totalAccrued'">
      {{ stats.totalAccrued.toLocaleString() }}
    </template>
  </div>
</template>

<script>
export default {
  props: ["column", "stats"],

  methods: {
    formatTime(min = 0) {
      let h = Math.floor(min / 60);
      let m = min % 60;

      h = `${h}`.padStart(2, "0");
      m = `${m}`.padStart(2, "0");

      return `${h}:${m}`;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";
.cell {
  display: flex;
}
.timeline {
  display: flex;
  margin-top: -1px;
  margin-bottom: -1px;
  margin-right: -1px;
}
.day {
  width: 24px;
  flex-shrink: 0;
  cursor: pointer;
  border: 1px solid #dfe4ef;
  margin-left: -1px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
